export default __webpack_public_path__ + "assets/wind-beaufort-2.819e1143.svg";